// src/app/routes/publicRoutes.jsx
import React, { lazy } from "react";
import { Route } from "react-router-dom";

const HomePage = lazy(() => import("../../pages/HomePage"));
const RegistrasiPage = lazy(() => import("../../pages/RegistrasiPage"));
const RegisterResultPage = lazy(() => import("../../pages/RegisterResultPage"));
const BukuTamuPage = lazy(() => import("../../pages/BukuTamuPage"));
const GuestBookResultPage = lazy(() => import("../../pages/GuestBookResultPage"));
const CekAntrianPage = lazy(() => import("../../pages/CekAntrianPage"));
const LayananAmbulansPage = lazy(() => import("../../pages/LayananAmbulansPage"));
const AmbulanceResultPage = lazy(() => import("../../pages/AmbulanceResultPage"));
const AmbulanceTrackPage = lazy(() => import("../../pages/AmbulanceTrackPage"));
const AmbulansTokenPage = lazy(() => import("../../pages/AmbulansTokenPage"));
const TicketPage = lazy(() => import("../../pages/TicketPage"));
const LatePage = lazy(() => import("../../pages/LatePage"));
const InfoVaksinasiPage = lazy(() => import("../../pages/InfoVaksinasiPage"));
const BuletinPage = lazy(() => import("../../pages/BuletinPage"));
const SurveiKepuasanPage = lazy(() => import("../../pages/SurveiKepuasanPage"));
const SurveiKepuasanResultPage = lazy(() => import("../../pages/SurveiKepuasanResultPage"));

// SI ALBA public forms/results. Path lama dipertahankan untuk kompatibilitas.
const Timker2RiskAssessmentPage = lazy(() =>
  import("../../pages/timker2/Timker2RiskAssessmentPage")
);
const Timker2RiskAssessmentResultPage = lazy(() =>
  import("../../pages/timker2/Timker2RiskAssessmentResultPage")
);
const Timker2SampelLaboratoriumPage = lazy(() =>
  import("../../pages/timker2/Timker2SampelLaboratoriumPage")
);
const Timker2SampelLaboratoriumResultPage = lazy(() =>
  import("../../pages/timker2/Timker2SampelLaboratoriumResultPage")
);
const Timker2LaluLintasJenazahPage = lazy(() =>
  import("../../pages/timker2/Timker2LaluLintasJenazahPage")
);
const Timker2LaluLintasJenazahResultPage = lazy(() =>
  import("../../pages/timker2/Timker2LaluLintasJenazahResultPage")
);

/**
 * Route publik dikelompokkan di satu modul agar App hanya menjadi composition root.
 * Fungsi mengembalikan Fragment berisi <Route>, yang dapat diproses langsung Routes.
 */
export function renderPublicRoutes() {
  return (
    <>
      <Route path="/" element={<HomePage />} />

      <Route path="/registrasi" element={<RegistrasiPage />} />
      <Route path="/register" element={<RegistrasiPage />} />
      <Route path="/register/result" element={<RegisterResultPage />} />

      <Route path="/buku-tamu" element={<BukuTamuPage />} />
      <Route path="/guest/result" element={<GuestBookResultPage />} />
      <Route path="/cek-antrian" element={<CekAntrianPage />} />
      <Route path="/layanan-ambulans" element={<LayananAmbulansPage />} />
      <Route path="/ambulans/result" element={<AmbulanceResultPage />} />
      <Route path="/ambulans/track" element={<AmbulanceTrackPage />} />
      <Route path="/ambulans/track/:token" element={<AmbulanceTrackPage />} />
      <Route path="/ambulans/t/:token" element={<AmbulansTokenPage />} />
      <Route path="/t/:token" element={<TicketPage />} />
      <Route path="/late" element={<LatePage />} />
      <Route path="/info-vaksinasi" element={<InfoVaksinasiPage />} />

      <Route path="/buletin" element={<BuletinPage />} />
      <Route path="/buletin/jenis/:jenisId" element={<BuletinPage />} />
      <Route path="/buletin/edisi/:edisiId" element={<BuletinPage />} />

      <Route path="/survei-kepuasan" element={<SurveiKepuasanPage />} />
      <Route
        path="/survei-kepuasan/result"
        element={<SurveiKepuasanResultPage />}
      />

      <Route path="/sra-kedatangan-kapal" element={<Timker2RiskAssessmentPage />} />
      <Route
        path="/sra-kedatangan-kapal/feedback"
        element={<Timker2RiskAssessmentResultPage />}
      />
      <Route
        path="/sra-kedatangan-kapal/result"
        element={<Timker2RiskAssessmentResultPage />}
      />
      <Route path="/sampel-laboratorium" element={<Timker2SampelLaboratoriumPage />} />
      <Route
        path="/sampel-laboratorium/feedback"
        element={<Timker2SampelLaboratoriumResultPage />}
      />
      <Route
        path="/sampel-laboratorium/result"
        element={<Timker2SampelLaboratoriumResultPage />}
      />
      <Route path="/lalu-lintas-jenazah" element={<Timker2LaluLintasJenazahPage />} />
      <Route
        path="/lalu-lintas-jenazah/feedback"
        element={<Timker2LaluLintasJenazahResultPage />}
      />
      <Route
        path="/lalu-lintas-jenazah/result"
        element={<Timker2LaluLintasJenazahResultPage />}
      />
    </>
  );
}
